import { requiredCustomSelectScheme, vehicleNumberScheme } from '@sravni/cosago-react-library/lib/validationSchemes';
import type { ObjectSchema, StringSchema } from 'yup';
import { boolean, object } from 'yup';

import { FieldErrors } from 'shared/lib/fields';

import type { TPledgeAutoFields } from '../types';

export const PledgeAutoValidationSchema = (isRequiredCarNumber?: boolean): ObjectSchema<TPledgeAutoFields> =>
  object({
    carBrand: requiredCustomSelectScheme<NonNullable<TPledgeAutoFields['carBrand']>>(),
    carModel: requiredCustomSelectScheme<NonNullable<TPledgeAutoFields['carModel']>>(),
    carManufactureYear: requiredCustomSelectScheme(),
    carNumber: isRequiredCarNumber
      ? vehicleNumberScheme().required(FieldErrors.requiredError)
      : (vehicleNumberScheme() as StringSchema<string>),
    enginePower: requiredCustomSelectScheme(),
    isTaxi: boolean<boolean>(),
    isOwner: boolean<boolean>(),
  });
